export default "__VITE_ASSET__lSiiZuHo__"